import React from "react";
import "./second.css";
class SecondPage extends React.Component {
  handleResume = e => {
    e.preventDefault();
    // console.log('hwllo cv')
    window.open(
      "https://drive.google.com/open?id=1nkyKJYFdKmU62v5EHMNdbyDlIR07u6Hw",
      "_blanck"
    );
  };
  handleWork = e => {
    e.preventDefault();
    // console.log('hwllo cv')
    window.open("https://www.github.com/errorr404", "_blanck");
  };
  handleEmail = e => {
    e.preventDefault();
    window.location.href = "mailto:dkbishwash@gmail.com";
  };
  render() {
    return (
      <div
        className="page-two-wrap"
        style={{ backgroundColor: "black", height: "100vh" }}
      >
        <div className="display-wrap">
          <div className="display">
            <i class="far fa-file" onClick={this.handleResume} />
            <h3>My resume</h3>
          </div>
          <div className="display">
            <i class="fas fa-code" onClick={this.handleWork} />
            <h3>My work</h3>
          </div>
          <div className="display">
            <i class="far fa-id-badge" onClick={this.handleEmail} />
            <h3>Contact me</h3>
          </div>
        </div>
      </div>
    );
  }
}
export default SecondPage;
